// pages/Studio.jsx — "El Estudio" → About + Arsenal/Process (no team)
import React from "react";
import About from "../sections/About.jsx";
import Stack from "../sections/Stack.jsx";

export default function PageStudio() {
  return (
    <>
      <About />
      <Stack />
    </>
  );
}
